module.exports = __webpack_public_path__ + "img/NewUI-NJLSsite.555ace92.png";